import { render, staticRenderFns } from "./goldDetail.vue?vue&type=template&id=1fa354dc&scoped=true"
import script from "./goldDetail.vue?vue&type=script&lang=js"
export * from "./goldDetail.vue?vue&type=script&lang=js"
import style0 from "./goldDetail.vue?vue&type=style&index=0&id=1fa354dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa354dc",
  null
  
)

export default component.exports